import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import { routes } from "Projects/config/routes";
import {
  ROLE_STUDENT,
  ROLE_SUPERVISOR,
} from "Projects/Constants/stringConstants";

const {
  guidance: { path },
} = routes;

const validateFunction = ({ path }) => {
  return _.includes([ROLE_STUDENT, ROLE_SUPERVISOR], path);
};

export default store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return withDynamicUrlValidation({
            component,
            urlValidationType: "customValidation",
            customUrlValidationFunction: validateFunction,
          });
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
